// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__37e4l","ranges":"BmiRanges_ranges__YrfYT"};